var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","height":"100%","width":"100%"}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.LoginLeftBgImage),expression:"LoginLeftBgImage"}],staticStyle:{"max-width":"100%","margin":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }